import styled from 'styled-components';

export const Footer = styled.footer`
    background-color: black;
    padding-top: 65px;
    padding-bottom: 65px;
    margin-top: auto;

    .the-guide { 
        padding-top:30px!important;
        text-align:right;
    }
    
    .footer-wrapper {
        padding-left:.5rem;
        padding-right:.5rem;
    }

    .for-tablet {
        display: none;
    }
    @media screen and (max-width: 920px) {
    {        
        .footer-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: center;
            max-width: 550px;
            margin: auto;
            row-gap: 30px
        }
        .the-guide { 
            padding-top:0!important;
            text-align:center;
        }
        .social-icons,.footer-links{
            justify-content: center!important;
        }
        .tablet-text-center {
            text-align: center;
        }
        .for-tablet {
            display: block;
        }
        .footer-wrapper div > div, .float-start.download-app {
            row-gap:10px
        }
        .float-start.download-app {
            display:flex!important;
            float:none!important;
            flex-direction:column
        }
        .invite-friends {
            text-align: center!important;
        }
        .footer-wrapper .col-md-4 {
            width: 100%;
        }
    }

    @media screen and (max-width: 480px) {
        .footer-wrapper {
            flex-direction: column;
        }
        .footer-wrapper .btMmDD {
            margin-top:0!important
        }
       
        .footer-wrapper .guide.mb-4  {
            margin-top:2rem!important
            margin-bottom:0rem!important
            
        }
    }

    @media screen and (max-width: 460px) {
        .sec-title {
            font-size: 16px;
        }
    }
    @media screen and (max-width: 430px) {
        .sec-title {
            font-size: 14px;
            letter-spacing: 0.15rem;
        }
    }
    @media screen and (max-width: 380px) {
        .sec-title {
            font-size: 13px;
        }
    }
    @media screen and (max-width: 340px) {
        .sec-title {
            font-size: 11px;
        }
    }
`;
export const SocialIcons = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: 0;
    flex-direction: column;
    justify-content: end;
    text-align:right;
`;

export const Icon = styled.a.attrs(props => ({
    className: 'vh-center'
}))`
    flex: 1;
    max-width: 36px;
    margin-left: 5px;
    margin-right: 5px;
    display: flex;

    img {
        width: 100%;
    }
`;

export const SiteLinks = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 30px;
    column-gap: 40px;
    @media screen and (max-width: 420px) {
        display: block;
    }
`;
export const SiteLink = styled.div`
    cursor: pointer;
`;

export const Form = styled.form`
    
    @media screen and (max-width: 920px) {
        justify-content: center;
    }
`;

export const FormDesc = styled.div`
    justify-content: center;
    display: flex;
    
    @media screen and (min-width: 920px) {
        justify-content: center;
    }
  
    div.message-wrapper {
        width: 100%;
        max-width: 380px;
        position: relative;
        top: 0px;
    }
`   
export const Copyright = styled.div`
    @media screen and (max-width: 920px) {
        display: none;
    }
`;